import styled from "styled-components";


export const Papa = styled.div`
  background-color: ${props => props.color};
`


export const Main = styled.div`
  @media (width > 1440px){
    width: 1440px;
  }
  padding: 0px 27px 0px 45px;
  padding-top: ${props => props.padtop}px;
  padding-bottom: ${props => props.padbott}px;
  background-color: ${props => props.color};
  display: ${props => props.display};
  margin: 0 auto;
  margin-bottom: ${props => props.marbott}px;
  flex-wrap: ${props => props.wrap};
  @media (width <= 414px){
    padding: 0px 10px 0px 10px;
    padding-top: ${props => props.padtop- 10}px;
    padding-bottom: ${props => props.padbott-10}px;
    
  }
`
export const OrnImg = styled.img`
    position: relative;
    top: ${props => props.top}px;
    left: ${props => props.left}px;
    right: ${props => props.right}px;
    bottom: ${props => props.bottom}px;
    @media(width < 1440px){
      left: ${props => props.left - 30}px;
    }
    @media(width < 1000px){
        display: none;
    }
`

export const Inscription = styled.p`
  color: ${props => props.color};
  font-size: ${props => props.size}px;
  font-weight: ${props => props.weight};
  margin: 0 0;
  span{
      color: #272727;
  } 
`
export const EndDiv =styled.div`
    display: flex;
    padding-top: ${props => props.padtop}px;
    padding-bottom: ${props => props.padbot}px;
    flex-wrap: wrap;
`
export const EndeText = styled.p`
    margin: 0 0;
    color: #FFFFFF;
    font-size: 24px;
    flex: 1;
    display: flex;
    &::after{
        content: '';
        border-bottom: 1px solid;
        flex: 1;
        margin: 0 .5em;
    }
`
export const EndText2 = styled.p`
    margin: 0 0;
    color: #FFFFFF;
    font-size: 24px;
`
export const TextTitle = styled.p`
    font-size: 52px;
    color: #FFFFFF;
    text-align: center;
`

export const UpDiv = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @media(width <= 828px){
        gap: 10px;
        justify-content: center;
    }
    padding-top:  ${props => props.padtop}px;
`
export const Icons = styled.div`
    display: flex;
    padding-right: 9px;
    gap: 20px;
    @media(width < 804px){
        padding-right: 0;
        flex-wrap: wrap;
        flex-direction: column;        
    }
    @media(width <= 828px){
        flex-direction: row; 
    }
`
export const IconImg = styled.img`
    max-width: ${props => props.width}px;
    max-height: ${props => props.height}px;
`
export const Icons2 =styled.div`
    display: flex;
    align-items: center;
    gap: 13px;
`